module.exports = __webpack_public_path__ + "static/img/icon_point.5b3cdb2.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon_point.svg
// module id = tXQe
// module chunks = 1